import React, { useRef, useEffect } from 'react';

const FiveWhysInfoGraphics = ({
    title,
    problemCode,
    category,
    subCategory,
    concern,
    problemStatement,
    why1,
    why2,
    why3,
    why4,
    why5,
    rootCause,
    fontSize,
    lineHeight,
    maxWidth,

    startXTitle,
    startYTitle,
    startXProblemCode,
    startYProblemCode,
    startXCategory,
    startYCategory,
    startXSubCategory,
    startYSubCategory,

    startXConcern,
    startYConcern,
    startXProblemStatement,
    startYProblemStatement,
    startXWhy1,
    startYWhy1,
    startXWhy2,
    startYWhy2,
    startXWhy3,
    startYWhy3,
    startXWhy4,
    startYWhy4,
    startXWhy5,
    startYWhy5,
    startXRootCause,
    startYRootCause,
    imageSrc,
    viewWidth,
}) => {
    const canvasRef = useRef(null);

    function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
        var words = text.split(' ');
        var line = '';
        for (var i = 0; i < words.length; i++) {
            var testLine = line + words[i] + ' ';
            var metrics = ctx.measureText(testLine);
            var testWidth = metrics.width;
            if (testWidth > maxWidth && i > 0) {
                ctx.fillText(line, x, y);
                line = words[i] + ' ';
                y += lineHeight;
            } else {
                line = testLine;
            }
        }
        ctx.fillText(line, x, y);
    }

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        maxWidth = viewWidth; //viewWidth;

        // Draw the image
        const image = new Image();
        image.onload = function () {
            canvas.width = image.width;
            canvas.height = image.height;

            ctx.drawImage(image, 0, 0);

            // Draw the elements
            ctx.font = `${fontSize}px Arial`;
            wrapText(ctx, concern, startXConcern, startYConcern, maxWidth, lineHeight);
            wrapText(ctx, problemStatement, startXProblemStatement, startYProblemStatement, maxWidth, lineHeight);
            wrapText(ctx, why1, startXWhy1, startYWhy1, maxWidth, lineHeight);
            wrapText(ctx, why2, startXWhy2, startYWhy2, maxWidth, lineHeight);
            wrapText(ctx, why3, startXWhy3, startYWhy3, maxWidth, lineHeight);
            wrapText(ctx, why4, startXWhy4, startYWhy4, maxWidth, lineHeight);
            wrapText(ctx, why5, startXWhy5, startYWhy5, maxWidth, lineHeight);
            wrapText(ctx, rootCause, startXRootCause, startYRootCause, maxWidth, lineHeight);
        };
        image.src = imageSrc;
    }, [
        title,
        problemCode,
        category,
        subCategory,
        concern,
        problemStatement,
        why1,
        why2,
        why3,
        why4,
        why5,
        rootCause,
        fontSize,
        lineHeight,
        maxWidth,

        startXTitle,
        startYTitle,
        startXProblemCode,
        startYProblemCode,
        startXCategory,
        startYCategory,
        startXSubCategory,
        startYSubCategory,

        startXConcern,
        startYConcern,
        startXProblemStatement,
        startYProblemStatement,
        startXWhy1,
        startYWhy1,
        startXWhy2,
        startYWhy2,
        startXWhy3,
        startYWhy3,
        startXWhy4,
        startYWhy4,
        startXWhy5,
        startYWhy5,
        startXRootCause,
        startYRootCause,
        imageSrc,
        viewWidth,
    ]);

    return (
        <canvas
            ref={canvasRef}
            style={{
                maxWidth: '100%',
            }}
        ></canvas>
    );
};

export default FiveWhysInfoGraphics;
